import React, { useState, useEffect, useMemo, use, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Typography,
  Chip,
  Paper,
  styled,
  useMediaQuery
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
// import { ContentCopy, AccountBalanceWallet } from "@mui/icons-material";
import CopyText from "../../../components/CopyText";
import FocusGhostLargeButton from "../../../components/NewButtons/FocusGhostLargeButton";
import { ReactComponent as DepositIcon } from "../../../assets/icons/trade/deposit.svg";
import { ReactComponent as WithdrawIcon } from "../../../assets/icons/trade/withdraw.svg";
import FocusGhostButton from "../../../components/NewButtons/FocusGhostButton";
import { ReactComponent as SolIcon } from "../../../assets/icons/trade/sol.svg";
import { ReactComponent as AgiIcon } from "../../../assets/icons/trade/agi.svg";
import { ReactComponent as QuestionIcon } from "../../../assets/icons/question.svg";
import { tableCellClasses } from "@mui/material/TableCell";
import { getRewards } from "../../../redux/slices/history";
import {
  getDMAInfo,
  signDepositSol,
  signWithdrawSol,
  withdrawSol,
  depositSol
} from "../../../redux/slices/DMA";
import { useDispatch, useSelector } from "react-redux";
import { displayNum, withComma } from "../../../utils/strings";
import Google2FAVerifyDialog from "../../../components/Dialogs/Google2FAVerifyDialog";
import BindConfirmDialog from "../../../components/Dialogs/BindConfirmDialog";
import {
  getConnectedSolanaWalletAddress,
  getTokenBalance,
  connectSolanaWallet,
  createTokenAccount,
  clientSign,
  setBindWalletNotice,
  wrongWalletAlert
} from "../../../redux/slices/wallet";
import { isSolWalletBound, getUserInfo } from "../../../redux/slices/auth";
import {
  setBindGoogle2FADialogOpen,
  setBindGoogle2FACallback,
  setCurrentFlow,
  setCurrentDialogStep
} from "../../../redux/slices/account";
import ReactGA from "react-ga4";
import { formatDate } from "../../../utils/time";

import Pagination from "../../../components/Pagination";
import BigNumber from "bignumber.js";
import { config } from "../../../config";
import BackButton from "../../../components/NewButtons/BackButton";
import RefreshIcon from "../../../assets/refresh.png";
import {
  NOTIF_FAIL,
  NOTIF_PROGRESSING,
  NOTIF_SUCCESS,
  setNotification
} from "../../../redux/slices/notifications";
import LineBgImage from "../../../assets/icons/dashboard/lines-bg.png";
import { ReactComponent as EmptyIcon } from "../../../assets/icons/dashboard/empty.svg";
import HintDialog from "../../../components/Dialogs/HintDialog";

// 自定义样式组件
const StyledButton = styled(LoadingButton)(({ theme, variant }) => ({
  fontFamily: "Canva Sans Sans",
  backgroundColor: variant === "contained" ? "var(--brand)" : "transparent",
  border: variant === "outlined" ? "1px solid var(--brand)" : "none",
  color: variant === "contained" ? "#000" : "var(--brand)",
  padding: theme.spacing(1.5, 4),
  borderRadius: 8,
  width: "270px",
  height: "50px",
  "&:hover": {
    backgroundColor: variant === "contained" ? "var(--brand)" : "rgba(255, 107, 0, 0.1)"
  },

  [theme.breakpoints.down("sm")]: {
    width: "100%"
  }
}));

const StyledTextField = styled(TextField)({
  fontFamily: "Canva Sans Sans",
  "& .MuiInputBase-root": {
    color: "white"
    // backgroundColor: "rgba(255, 255, 255, 0.05)",
    // borderRadius: 8,
    // "& fieldset": {
    //   borderColor: "rgba(255, 255, 255, 0.1)"
    // },
    // "&:hover fieldset": {
    //   borderColor: "rgba(255, 255, 255, 0.2)"
    // }
  },
  "& .MuiInputLabel-root": {
    color: "rgba(255, 255, 255, 0.7)"
  }
});

const StatusChip = styled(Chip)(({ status }) => ({
  backgroundColor:
    status === "PENDING"
      ? "rgba(255, 165, 0, 0.2)"
      : status === "CANCELED"
      ? "rgba(255, 0, 0, 0.2)"
      : "rgba(0, 255, 0, 0.2)",
  color: status === "PENDING" ? "orange" : status === "CANCELED" ? "red" : "green",
  borderRadius: 4
}));

const StyledTableHeadRow = styled(TableRow)(({ theme }) => ({
  border: "0.5px solid #FF8736 !important",
  backgroundColor: "transparent !important",
  fontFamily: "Canva Sans Sans"
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  color: "white",
  borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
  padding: "20px 30px",
  backgroundColor: "#000",
  fontFamily: "Canva Sans Sans",

  [`&.${tableCellClasses.head}`]: {
    color: "#FF8736",
    fontSize: 14,
    fontWeight: "500",
    // `url(${LineBgImage}) rgba(255, 135, 54, 0.3)`,
    // background: ` rgba(255, 135, 54, 0.4)`,
    // "background-blend-mode": "soft-light, normal, normal",
    background: `
    linear-gradient(0, rgba(255, 135, 54, 0.30) 0%, rgba(255, 135, 54, 0.30) 100%),
    url(${LineBgImage})`,
    border: "none"
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  },

  [theme.breakpoints.down("sm")]: {
    padding: "10px 20px",
    [`&.${tableCellClasses.head}`]: {
      fontSize: 12
    }
  }
}));

function TradeView() {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const [activeTab, setActiveTab] = useState(query.get("type") || "deposit");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [walletAmount, setWalletAmount] = useState("");
  // const [walletAddress, setwalletAddress] = useState("");
  const { push } = useHistory();
  const { userInfo } = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [walletBalance, setWalletBalance] = useState(0);
  const [isShowBind2FAConfirm, setIsShowBind2FAConfirm] = useState(false);
  const [isShowVerifyDialog, setIsShowVerifyDialog] = useState(false);
  const [historyList, setHistoryList] = useState([]);
  const { isLoading, rewards, failedTx } = useSelector((state) => state.history);
  const [processing, setProcessing] = useState(false);
  const [currentTime, setCurrentTime] = useState(Date.now());
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const walletAddress = useMemo(() => {
    return user?.wallets?.solWallet;
  }, [user]);
  const balance = useMemo(() => {
    return userInfo?.dely_balance_agi;
  }, [userInfo]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(Date.now());
    }, 60 * 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (isSolWalletBound(user)) {
      connectSolanaWallet();
    }
  }, [user]);

  const checkIsWrongWallet = useCallback(async () => {
    if (isSolWalletBound(user)) {
      const curWallet = await getConnectedSolanaWalletAddress();
      const isWrongWallet = curWallet !== walletAddress;

      if (isWrongWallet) {
        dispatch(wrongWalletAlert(walletAddress, activeTab));
        return true;
      }
    }
  }, [activeTab, dispatch, user, walletAddress]);
  // 判断当前solana绑定的钱包和用户的钱包是否一致
  useEffect(() => {
    checkIsWrongWallet();
  }, [checkIsWrongWallet, dispatch, user, walletAddress]);

  const getHistoryList = useCallback(
    async (page = 1) => {
      dispatch(
        getRewards({
          types: activeTab === "withdraw" ? "1" : "16",
          page,
          page_size: rowsPerPage
        })
      );
      // setHistoryList(response.data);
    },
    [activeTab, dispatch, rowsPerPage]
  );

  useEffect(() => {
    getHistoryList();
  }, [activeTab]);

  function handleChangePage(e, value) {
    setPage(value);
    getHistoryList(value);
  }

  const onRefreshBalance = useCallback(async () => {
    if (activeTab === "withdraw") {
      dispatch(getUserInfo());
    } else {
      // 替换为实际的钱包地址
      const walletAddress = await getConnectedSolanaWalletAddress();
      const tokenMintAddress = config.SOL_AGI_CONTRACT; // 替换为实际的代币 Mint 地址
      const balance = await getTokenBalance(walletAddress, tokenMintAddress);
      // console.log(`Token Balance: ${balance}`);
      setWalletBalance(balance);
    }
  }, [activeTab, dispatch]);

  useEffect(() => {
    onRefreshBalance();
  }, [onRefreshBalance]);

  // TODO: 删除
  // console.log("walletBalance", walletBalance);

  const checkWalletBind = useCallback(() => {
    if (!isSolWalletBound(user)) {
      dispatch(setBindWalletNotice(true));
      return;
    }
    // if (!isActive) {
    //   dispatch(setWalletDialogOpen({ open: true }));
    //   return;
    // }
  }, [user]);

  useEffect(() => {
    checkWalletBind();
  }, [checkWalletBind]);

  useEffect(() => {
    setActiveTab(query.get("type") || "deposit");
  }, [search]);

  useEffect(() => {
    dispatch(getUserInfo());
    dispatch(getDMAInfo());
  }, [dispatch]);

  // 模拟历史记录数据
  // const history = [
  //   {
  //     time: "Jan 12 2025 12:12:12",
  //     agi: "99,999.9999 AGI",
  //     balance: "99,999.9999 AGI",
  //     network: "Solana",
  //     status: "PENDING"
  //   },
  //   {
  //     time: "Jan 12 2025 12:12:12",
  //     agi: "99,999.9999 AGI",
  //     balance: "99,999.9999 AGI",
  //     network: "Solana",
  //     status: "CANCELED"
  //   }
  //   // ... 更多数据
  // ];

  const handleCopyAddress = () => {
    navigator.clipboard.writeText(walletAddress);
    // 可以添加复制成功的提示
  };

  const handleMaxAmount = () => {
    if (activeTab === "withdraw") {
      setWalletAmount(balance); // 设置为最大可用余额
    } else {
      setWalletAmount(walletBalance); // 设置为最大可用余额
    }
  };

  const handleDepositClick = async () => {
    // @TODO: Handle deposit request
    checkWalletBind();

    dispatch(
      signDepositSol({
        currency: "DES",
        chain: "SOL",
        amount: new BigNumber(walletAmount).toString(),
        wallet_address: walletAddress
      })
    )
      .then((signData) => {
        dispatch(
          depositSol({
            signData,
            callback: () => {
              setProcessing(false);
              // setClose();
              getHistoryList(page);
            },
            onError: () => {
              setProcessing(false);
              getHistoryList(page);
            }
          })
        );
      })
      .catch((error) => {
        console.log("handleDepositClick", error);
        setProcessing(false);
        getHistoryList(page);
      });

    // try {
    //   const signData = await dispatch(
    //     signDeposit({
    //       currency: 'DES',
    //       chain: 'BSC',
    //       amount: new BigNumber(amount).toString(),
    //       wallet_address: account
    //     })
    //   )
    //   await dispatch(deposit({ provider, signData }));
    //   setClose()
    // } catch (error) {
    //   console.log('handleDepositClick', error)
    // }
  };
  async function handleWithdraw(code) {
    checkWalletBind();
    // if (isWrongWallet) {
    //   dispatch(wrongWalletAlert(correctWallet));
    //   return;
    // }

    // if (isWrongNetwork) {
    //   const switchSuccess = await handleChangeNetwork(selectedNetwork);
    //   if (!switchSuccess) {
    //     dispatch(wrongNetworkAlert(networks[selectedNetwork]));
    //   }
    //   return;
    // }

    // @Case: No binding 2FA
    if (!userInfo.info.authenticator.bound) {
      setIsShowBind2FAConfirm(true);
      setProcessing(false);
      return;
    }

    // @Case: Bound 2FA & No verify code
    if (userInfo.info.authenticator.bound && userInfo.info.authenticator.enabled && !code) {
      setIsShowVerifyDialog(true);
      setProcessing(false);
      return;
    }

    return dispatch(signWithdrawSol(walletAmount.toString(), "DES", "SOL", String(code)))
      .then((signData) => {
        setIsShowVerifyDialog(false);
        dispatch(
          withdrawSol({
            signData,
            callback: () => {
              setProcessing(false);
              getHistoryList(page);
              dispatch(getUserInfo());
            },
            onError: () => {
              setProcessing(false);
              getHistoryList(page);
              dispatch(getUserInfo());
            }
          })
        );
      })
      .catch((error) => {
        console.log("handleWithdraw", error);
        setProcessing(false);
        getHistoryList(page);
        dispatch(getUserInfo());
      });
  }

  useEffect(() => {
    if (rewards?.data) {
      setHistoryList(rewards?.data);
    } else {
      setHistoryList([]);
    }
  }, [rewards?.data]);

  const handleTrade = async () => {
    if (processing) {
      return;
    }

    const isWrongWalletCheck = await checkIsWrongWallet();
    if (isWrongWalletCheck) {
      return;
    }

    setProcessing(true);
    if (!walletAmount) {
      // 提示用户输入金额
      return;
    }
    if (activeTab === "withdraw") {
      // const serializedTx = await dispatch(signWithdrawSol({
      //   amount: walletAmount,
      //   wallet_address: walletAddress,
      //   currency: "DES",
      //   chain: "SOL"
      // }))
      // console.log("serializedTx:", serializedTx);
      // const signature = await clientSign(serializedTx);
      // console.log("Signature:", signature);
      // 5Fuig8TsHDJJKJwdvKhk2Dw3iVvoEQw6x73KGPnyXfAg
      handleWithdraw();
    } else {
      // const serializedTx = await signDepositSol({
      //   amount: walletAmount,
      //   wallet_address: walletAddress,
      //   currency: "DES",
      //   chain: "SOL"
      // });
      // const signature = await clientSign(serializedTx);
      // console.log("Signature:", signature);
      handleDepositClick();
    }
  };

  // 判断传入时间是否和当前时间相差超过5分钟
  const isTimeOut5m = (time) => {
    // 判断传入时间是否需要 * 1000
    if (time.toString().length === 10) {
      time = time * 1000;
    }

    const now = currentTime;
    const target = new Date(time);
    return now - target > 5 * 60 * 1000;
  };

  const onRetry = (row) => {
    if (row.status === 0 && isTimeOut5m(row.created_at)) {
      setWalletAmount(Math.abs(row.amount));
      if (activeTab === "withdraw") {
        handleWithdraw();
      } else {
        handleDepositClick();
      }
    }
  };

  return (
    <Box
      sx={{
        bgcolor: "black",
        color: "white",
        paddingTop: isMobile ? "0" : "50px",
        paddingBottom: "100px",
        paddingLeft: isMobile ? "0px" : "16pX",
        paddingRight: isMobile ? "0px" : "16pX"
      }}>
      <Box sx={{ display: "flex", mb: 4, mt: isMobile ? 0 : "10px" }}>
        <BackButton>Back</BackButton>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          margin: "0 auto",
          width: isMobile ? "100%" : "959px"
        }}>
        {/* 存款/取款切换 */}
        <Box
          sx={{
            display: "flex",
            mb: 4,
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "8px" : "0"
          }}>
          <FocusGhostLargeButton
            className={activeTab === "deposit" ? "active" : ""}
            variant={activeTab === "deposit" ? "contained" : "outlined"}
            onClick={() => push("/trade?type=deposit")}>
            <Box
              sx={{
                display: "flex",
                width: "100%",
                padding: isMobile ? "12px" : 0,
                gap: isMobile ? "12px" : "20px",
                alignItems: "center",
                justifyContent: isMobile ? "flex-start" : "center"
              }}>
              <Box>
                <DepositIcon
                  width={isMobile ? "32px" : "64px"}
                  height={isMobile ? "32px" : "64px"}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "4px",
                  fontSize: isMobile ? "14px" : "20px",
                  fontFamily: "Canva Sans Sans",
                  fontWeight: 400,
                  width: isMobile ? "90%" : "54%"
                }}>
                DEPOSIT
                <Box
                  variant="caption"
                  sx={{
                    display: "block",
                    opacity: 0.7,
                    fontFamily: "Canva Sans Sans",
                    fontSize: isMobile ? "10px" : "12px",
                    textAlign: "left"
                  }}>
                  Deposit token from your wallet to Delysium One
                </Box>
              </Box>
            </Box>
          </FocusGhostLargeButton>
          <FocusGhostLargeButton
            className={activeTab === "withdraw" ? "active" : ""}
            variant={activeTab === "withdraw" ? "contained" : "outlined"}
            onClick={() => push("/trade?type=withdraw")}>
            <Box
              sx={{
                display: "flex",
                gap: isMobile ? "12px" : "20px",
                padding: isMobile ? "12px" : 0,
                width: "100%",
                alignItems: "center",
                justifyContent: isMobile ? "flex-start" : "center"
              }}>
              <Box>
                <WithdrawIcon
                  width={isMobile ? "32px" : "64px"}
                  height={isMobile ? "32px" : "64px"}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontSize: isMobile ? "14px" : "20px",
                  fontFamily: "Canva Sans Sans"
                }}>
                WITHDRAW
              </Box>
            </Box>
          </FocusGhostLargeButton>
        </Box>

        {/* 提现资产选择 */}
        {activeTab === "withdraw" ? (
          <Typography
            variant="subtitle2"
            sx={{ mb: "20px" }}
            fontFamily="Canva Sans Sans"
            fontWeight={400}
            fontSize={16}
            letterSpacing={1.28}>
            ASSET
          </Typography>
        ) : null}
        {activeTab === "withdraw" ? (
          <Box sx={{ mb: "50px", width: isMobile ? "100%" : "600px" }}>
            <FocusGhostButton
              className="active"
              sx={{
                width: "120px",
                height: "40px",
                minHeight: "40px",
                color: "white",
                fontSize: "16px",
                fontWeight: 400,
                fontFamily: "Canva Sans Sans"
              }}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Box
                  sx={{
                    width: "20px",
                    height: "20px",
                    borderRadius: "999px",
                    border: "0.5px solid #323232",
                    background: "#000",
                    marginRight: "8px"
                  }}>
                  <AgiIcon />
                </Box>
                AGI
              </Box>
            </FocusGhostButton>
          </Box>
        ) : null}

        {/* 网络选择 */}
        <Typography
          variant="subtitle2"
          sx={{ mb: "20px" }}
          fontFamily="Canva Sans Sans"
          fontWeight={400}
          fontSize={16}
          letterSpacing={1.28}>
          NETWORK
        </Typography>
        <Box sx={{ mb: "50px", width: isMobile ? "100%" : "600px" }}>
          <FocusGhostButton
            className="active"
            sx={{
              width: "120px",
              height: "40px",
              minHeight: "40px",
              color: "white",
              fontSize: "16px",
              fontWeight: 400,
              fontFamily: "Canva Sans Sans"
            }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Box
                sx={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "999px",
                  border: "0.5px solid #323232",
                  background: "#000",
                  marginRight: "8px"
                }}>
                <SolIcon />
              </Box>
              SOL
            </Box>
          </FocusGhostButton>
        </Box>

        {/* 存款地址 */}
        <Typography
          sx={{ mb: "20px" }}
          fontFamily="Canva Sans Sans"
          fontWeight={400}
          fontSize={16}
          letterSpacing={1.28}>
          {activeTab === "withdraw" ? "WITHDRAW TO" : "DEPOSIT FROM"}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mb: "50px",
            width: isMobile ? "100%" : "600px",
            border: "0.5px solid #323232"
          }}>
          <StyledTextField fullWidth value={walletAddress} InputProps={{ readOnly: true }} />
          <Button onClick={handleCopyAddress} sx={{ ml: 1 }}>
            <CopyText />
          </Button>
        </Box>

        {/* 存款金额 */}
        <Typography
          sx={{ mb: "20px" }}
          fontFamily="Canva Sans Sans"
          fontWeight={400}
          fontSize={16}
          letterSpacing={1.28}>
          {activeTab === "withdraw" ? "WITHDRAW AMOUNT" : "DEPOSIT AMOUNT"}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mb: "8px",
            width: isMobile ? "100%" : "600px",
            border: "0.5px solid #323232"
          }}>
          <StyledTextField
            fullWidth
            placeholder="Please Enter"
            value={walletAmount}
            onChange={(e) => setWalletAmount(e.target.value)}
          />
          <Typography
            fontFamily="Canva Sans Sans"
            fontWeight={400}
            fontSize={16}
            letterSpacing={1.28}
            padding={"0 0 0 8px"}>
            AGI
          </Typography>
          <Button onClick={handleMaxAmount} sx={{ ml: 1, color: "#FF8736" }}>
            MAX
          </Button>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: isMobile ? "100%" : "600px",
            mb: "50px"
          }}>
          <Box
            sx={{
              color: "rgba(255, 255, 255, 0.6)",
              display: "flex",
              alignItems: "center"
            }}>
            <Typography
              variant="caption"
              sx={{ display: "block", mr: "4px" }}
              fontFamily={"Poppins"}
              fontSize={14}
              color={"rgba(255, 255, 255, 0.6)"}>
              {activeTab === "withdraw"
                ? `${displayNum(balance || 0)} AGI Available`
                : `Wallet Balance: ${walletBalance || 0} AGI`}
            </Typography>
            <Box
              component={"img"}
              src={RefreshIcon}
              onClick={() => {
                onRefreshBalance();
                dispatch(
                  setNotification({
                    // 刷新余额
                    title: "Refresh Balance",
                    type: NOTIF_SUCCESS,
                    // 已获取最新余额
                    description: "Successfully refreshed balance"
                  })
                );
              }}
              sx={{
                width: "18px",
                height: "18px",
                cursor: "pointer",
                transition: "all 0.3s",
                "&:hover": {
                  transform: "rotate(180deg)"
                }
              }}></Box>
          </Box>

          {activeTab === "withdraw" ? (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <QuestionIcon />
              <Typography
                variant="caption"
                sx={{ display: "block", ml: "5px" }}
                fontFamily={"Poppins"}
                fontWeight={400}
                fontSize={14}
                color={"rgba(255, 255, 255, 0.6)"}>
                Gas fees need to be provided for withdrawal
              </Typography>
            </Box>
          ) : null}
        </Box>

        {/* 操作按钮 */}
        <Box sx={{ display: "flex", gap: "60px", mb: "50px" }}>
          {/* <StyledButton variant="outlined" fullWidth>
          CANCEL
        </StyledButton> */}
          <StyledButton
            variant="contained"
            loading={processing}
            loadingIndicator={"Processing..."}
            fullWidth
            onClick={() => handleTrade()}
            disabled={!+walletAmount || processing}>
            {activeTab === "withdraw" ? "WITHDRAW" : "DEPOSIT"}
          </StyledButton>
        </Box>

        {/* 历史记录 */}
        <Typography
          sx={{ mb: "20px" }}
          fontFamily="Canva Sans Sans"
          fontWeight={400}
          fontSize={isMobile ? 14 : 16}
          letterSpacing={1.28}>
          {/* DEPOSIT HISTORY */}
          {activeTab === "withdraw" ? "WITHDRAW HISTORY" : "DEPOSIT HISTORY"}
        </Typography>
        <TableContainer
          sx={{
            maxWidth: isMobile ? "100%" : "960px"
          }}>
          <Table>
            <TableHead>
              <StyledTableHeadRow>
                <StyledTableCell sx={{ color: "white" }}>Time</StyledTableCell>
                <StyledTableCell sx={{ color: "white" }}>AGI</StyledTableCell>
                <StyledTableCell sx={{ color: "white" }}>Balance</StyledTableCell>
                <StyledTableCell sx={{ color: "white" }}>Network</StyledTableCell>
                <StyledTableCell sx={{ color: "white" }}>Status</StyledTableCell>
              </StyledTableHeadRow>
            </TableHead>
            <TableBody
              sx={{
                border: "0.5px solid #323232"
              }}>
              {historyList?.length ? (
                historyList.map((row, index) => (
                  <TableRow key={index}>
                    <StyledTableCell sx={{ color: "white" }}>
                      {formatDate(row.created_at)}
                    </StyledTableCell>
                    <StyledTableCell sx={{ color: "white" }}>{row.amount}</StyledTableCell>
                    <StyledTableCell sx={{ color: "white" }}>{row.balance}</StyledTableCell>
                    <StyledTableCell sx={{ color: "white" }}>
                      {row.chain === "-" ? "SOL" : row.chain}
                    </StyledTableCell>
                    <StyledTableCell>
                      {/* <StatusChip label={row.status} status={row.status} size="small" /> */}
                      {row.status === 0 ? (
                        <Typography
                          variant="caption"
                          sx={{
                            color: (theme) => theme.palette.error.dark,
                            fontWeight: 600,
                            cursor: isTimeOut5m(row.created_at) ? "pointer" : "default",
                            textDecoration: isTimeOut5m(row.created_at) ? "underline" : "none"
                          }}
                          onClick={() => onRetry(row)}>
                          {isTimeOut5m(row.created_at) ? "Retry" : "Unfinished"}
                        </Typography>
                      ) : (
                        <Typography variant="caption" sx={{ color: "#7FFAE2", fontWeight: 600 }}>
                          {row.status === 1 ? "Completed" : "Pending"}
                        </Typography>
                      )}
                    </StyledTableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <StyledTableCell colSpan={5}>
                    <Box
                      sx={{
                        width: "100%",
                        padding: "110px 0",
                        margin: "0 auto",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column"
                      }}>
                      <EmptyIcon />
                      <Typography sx={{ mt: "8px", fontSize: "14px", fontWeight: 500 }}>
                        You Know I love You
                      </Typography>
                    </Box>
                  </StyledTableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <TablePagination
        component="div"
        count={history.length}
        page={page}
        onPageChange={(e, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
        sx={{ color: "white" }}
      /> */}
        {rewards?.total_page ? (
          <Pagination
            onChange={handleChangePage}
            count={Math.ceil(rewards?.total_page)}
            page={page}
          />
        ) : null}

        <BindConfirmDialog
          open={isShowBind2FAConfirm}
          setClose={() => {
            setIsShowBind2FAConfirm(false);
            setProcessing(false);
            dispatch(getUserInfo());
          }}
          tips={
            <>
              For your account safety, <br />
              please bind with&nbsp;
              <Box component="span" sx={{ color: (theme) => theme.palette.primary.main }}>
                Google Authenticator.
              </Box>
            </>
          }
          confirmHandler={() => {
            ReactGA.event("try_dmawithdrawAGI_2FA_bind");
            dispatch(setBindGoogle2FADialogOpen(true));
            dispatch(setBindGoogle2FACallback(null));
            setIsShowBind2FAConfirm(false);
          }}
        />
        <Google2FAVerifyDialog
          title={"Security Verification"}
          open={isShowVerifyDialog}
          setClose={() => {
            setIsShowVerifyDialog(false);
            setProcessing(false);
            dispatch(getUserInfo());
          }}
          onPrimaryClick={(code) => {
            return handleWithdraw(code);
          }}
        />
      </Box>
    </Box>
  );
}

export default TradeView;
